
























































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import shipmentStore from '@/stores/ShipmentStore'
import { Routes } from '@/router/routes'
import ShipmentPoint from '@/dto/deliveries/ShipmentPoint'
import { NotifyHelper } from 'vue-kit'

@Component
export default class PopupMenu extends Vue {
  @Prop(Object)
  shipmentPoint: ShipmentPoint
  shipmentStore = shipmentStore
  isShowConfirmDialog: boolean = false
  isShowErrorsDialog: boolean = false
  isShowMenu: boolean = false
  errorText: string = ''

  async removeShipmentPoint() {
    this.shipmentStore
      .removeShipmentPoint(this.shipmentPoint.id)
      .then(() => {
        if (
          this.$route.params.shipmentPointId ===
          this.shipmentPoint.id.toString()
        ) {
          this.$router.push({
            name: Routes.shipmentPoints,
          })
        }
      })
      .catch((error: string) => {
        this.errorText = error
        this.isShowConfirmDialog = false
        this.isShowErrorsDialog = true
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
      })
      .finally(() => {
        this.isShowConfirmDialog = false
      })
  }

  toggleEnabled() {
    this.shipmentStore.togglePointStatus(this.shipmentPoint.id)
  }

  get enabledBtnLabel() {
    return this.shipmentPoint.enabled ? 'Отключить' : 'Включить'
  }

  @Watch('isShowErrorsDialog')
  resetErrors(isShow: boolean) {
    if (!isShow) {
      this.errorText = ''
    }
  }
}
